export default "__VITE_ASSET__7iOn62_C__"